"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navbar = function Navbar(_ref) {
  var children = _ref.children,
      shadow = _ref.shadow,
      inverted = _ref.inverted;
  var navbarStyles = ['co-navbar', {
    'co-shadow--150': shadow
  }];
  var allowedModifiers = {
    inverted: inverted
  };
  return _react.default.createElement(_styler.default, {
    classNames: navbarStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

var NavbarType = function NavbarType(_ref2) {
  var children = _ref2.children,
      secondary = _ref2.secondary;
  var navbarStyles = [{
    'co-navbar__primary': !secondary,
    'co-navbar__secondary': secondary
  }];
  return _react.default.createElement(_styler.default, {
    classNames: navbarStyles
  }, function (styles) {
    return _react.default.createElement("nav", {
      className: styles
    }, children);
  });
};

var NavbarPrimary = function NavbarPrimary(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement(NavbarType, null, children);
};

var NavbarSecondary = function NavbarSecondary(_ref4) {
  var children = _ref4.children;
  return _react.default.createElement(NavbarType, {
    secondary: true
  }, children);
};

var NavbarContainer = function NavbarContainer(_ref5) {
  var children = _ref5.children,
      minimal = _ref5.minimal,
      pushLeft = _ref5.pushLeft,
      pushRight = _ref5.pushRight,
      pushHcenter = _ref5.pushHcenter;
  var containerStyles = ['co-navbar__container', {
    'co-navbar__container--min': minimal
  }];
  var allowedModifiers = {
    pushLeft: pushLeft,
    pushRight: pushRight,
    pushHcenter: pushHcenter
  };
  return _react.default.createElement(_styler.default, {
    classNames: containerStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

var Actions = function Actions(_ref6) {
  var children = _ref6.children;
  return _react.default.createElement("div", {
    className: "co-navbar__actions"
  }, children);
};

Navbar.propTypes = {
  children: (0, _airbnbPropTypes.childrenSequenceOf)({
    validator: (0, _airbnbPropTypes.elementType)(NavbarPrimary),
    min: 1,
    max: 1
  }, {
    validator: (0, _airbnbPropTypes.elementType)(NavbarSecondary),
    min: 0,
    max: 1
  }).isRequired,
  inverted: _propTypes.bool,
  shadow: _propTypes.bool,
  vertical: _propTypes.bool
};
var NavbarTypePropTypes = {
  children: _propTypes.node.isRequired
};
var navbarContainerAlignment = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('pushLeft', 'pushRight', 'pushHcenter');
NavbarContainer.propTypes = {
  children: _propTypes.node.isRequired,
  minimal: _propTypes.bool,
  pushLeft: navbarContainerAlignment,
  pushRight: navbarContainerAlignment,
  pushHcenter: navbarContainerAlignment
};
Actions.propTypes = {
  children: _propTypes.node.isRequired
};
NavbarPrimary.displayName = 'Navbar.Primary';
NavbarSecondary.displayName = 'Navbar.Secondary';
NavbarContainer.displayName = 'Navbar.Container';
Actions.displayName = 'Navbar.Actions';
NavbarPrimary.propTypes = NavbarTypePropTypes;
NavbarSecondary.propTypes = NavbarTypePropTypes;
Navbar.Primary = NavbarPrimary;
Navbar.Secondary = NavbarSecondary;
Navbar.Container = NavbarContainer;
Navbar.Actions = Actions;
var _default = Navbar;
exports.default = _default;
Navbar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Navbar",
  "props": {
    "children": {
      "type": {
        "name": "custom",
        "raw": "childrenSequenceOf(\n  { validator: elementType(NavbarPrimary), min: 1, max: 1 },\n  { validator: elementType(NavbarSecondary), min: 0, max: 1 }\n).isRequired"
      },
      "required": false,
      "description": ""
    },
    "inverted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "shadow": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "vertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};